import jsPDF from 'jspdf';

export const familiarMixin = {
    data: () => ({
    }),
    methods: {

        createQRPDF(fam) {
            this.getDataUri('@/assets/img/0_Skolable.png', (dataUri) => {
                var doc = new jsPDF("p", "pt", "a7");
                var pdfName = "QR";
                doc.setFontSize(10);
                doc.text(55, 145, "QR de Acceso Familiar");
                doc.text(55, 160, fam.firstName + " " + fam.lastName);
                var imgData = "data:image/png;base64," + fam.qri;
                doc.addImage("data:image/png;base64," + dataUri, "PNG", 55, 10, 100, 25);
                doc.addImage(imgData, "PNG", 55, 35, 100, 100);
                doc.save(pdfName + ".pdf");
            });
        },
        getDataUri(url, callback) {
            var image = new Image();
          
            image.onload = function() {
              var canvas = document.createElement('canvas');
              canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
              canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size
          
              canvas.getContext('2d').drawImage(this, 0, 0);
          
              // Get raw image data
              callback(canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''));
          
              // ... or get as Data URI
              //callback(canvas.toDataURL('image/png'));
            };
          
            image.src = require("@/assets/img/0_Skolable.png");
          }
    },
}